import { combineReducers } from 'redux';
import cartReducer from './cartReducer';
import settingReducer from './settingReducer';

export default combineReducers({
  cart: cartReducer,
  settings: settingReducer,
});
